import { useQuery } from "@tanstack/react-query";

import { getVendorInvoicesPdfUrl, vendorInvoicesList } from "@motolynk/api-client";
import { useFeature, type VendorOrderDocumentsProps } from "@motolynk/app-core";
import { useTranslation } from "@motolynk/i18n";
import { Card, CardContent, CardHeader, CardTitle } from "@motolynk/ui";

import { INVOICED_STATUSES, InvoiceLinks } from "../shared/InvoiceLinks";

/** Vendor order page: the store's GST invoice / credit notes for it (slot `orders.vendor_order.documents`). */
export function VendorInvoices({ vendorOrderNumber, status }: VendorOrderDocumentsProps) {
  const { t } = useTranslation("invoices");
  const enabled = useFeature("orders.gst_invoices") && INVOICED_STATUSES.includes(status);
  const query = { vendor_order: vendorOrderNumber, page_size: 50 };
  const rows = useQuery({
    queryKey: ["vendor", "invoices", query],
    queryFn: async () => (await vendorInvoicesList(query)).data,
    enabled,
  });
  if (!enabled) return null;
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("title")}</CardTitle>
      </CardHeader>
      <CardContent>
        <InvoiceLinks
          rows={rows.data?.results}
          loading={rows.isPending}
          failed={rows.isError}
          pdfUrl={getVendorInvoicesPdfUrl}
        />
      </CardContent>
    </Card>
  );
}
